export default __webpack_public_path__ + "static/media/krepelicky.91e5769f.jpg";